module.exports = __webpack_public_path__ + "img/bg.f8bc1ba4.png";